import { render, staticRenderFns } from "./ApexChartDonut.vue?vue&type=template&id=2d498962"
import script from "./ApexChartDonut.vue?vue&type=script&lang=js"
export * from "./ApexChartDonut.vue?vue&type=script&lang=js"
import style0 from "./ApexChartDonut.vue?vue&type=style&index=0&id=2d498962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports